import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("title", null, "89BBAB94-1F52-48DE-8B05-1D1B7033B28E", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "00_MovingLayers_UI_Design-System",
    transform: "translate(-196.000000, -4004.000000)"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Icon/Progress/0",
      transform: "translate(196.000000, 4004.000000)",
      stroke: "var(--lightGrey100)",
      "stroke-width": "2"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        id: "Oval",
        cx: "11",
        cy: "11",
        r: "10"
      })
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}